import { api } from './client';

const apiBase = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api').replace(/\/+$/, '');
const rootBase = apiBase.endsWith('/api') ? apiBase.slice(0, -4) : apiBase;

export const AuthAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  demoLogin: () => api.post('/auth/demo-explorer'),
  // Forgot / Reset
  requestReset: (email) => api.post('/auth/forgot-password', { email }),
  verifyResetToken: (token) => api.get(`/auth/reset-password/verify`, { params: { token } }),
  resetWithToken: (token, new_password) => api.post('/auth/reset-password', { token, new_password }),

  // Change Password (authenticated)
  changePassword: (old_password, new_password) =>
    api.post('/auth/change-password', { old_password, new_password }),

  googleStartUrl: (returnTo = '/') =>
    `${apiBase}/auth/google/start?returnTo=${encodeURIComponent(returnTo)}`,
  googleSignupStartUrl: (returnTo = '/') =>
    `${apiBase}/auth/google/signup/start?returnTo=${encodeURIComponent(returnTo)}`,
  m365StartUrl: (returnTo = '/') =>
    `${apiBase}/auth/m365/start?returnTo=${encodeURIComponent(returnTo)}`,
  m365SignupStartUrl: (returnTo = '/') =>
    `${apiBase}/auth/m365/signup/start?returnTo=${encodeURIComponent(returnTo)}`,
  oauthBase: rootBase,
};


